import type { ButtonProps } from '@mui/material';

import { Button } from '@mui/material';

interface TabButtonProps extends ButtonProps {
  isSelected?: boolean;
}

export function TabButton({ isSelected, sx, ...other }: TabButtonProps) {
  return (
    <Button
      variant={isSelected ? 'outlined' : 'text'}
      sx={{
        borderColor: isSelected ? 'primary.main' : 'primary.light',
        color: isSelected ? 'primary.main' : 'primary.light',
        fontWeight: isSelected ? 600 : 400,
        backgroundColor: isSelected ? 'rgba(104, 58, 183, 0.08)' : 'transparent',
        textTransform: 'none',
        minWidth: 0,
        px: 2,
        py: 0.5,
        boxShadow: isSelected ? 1 : 0,
        borderWidth: 1,
        borderStyle: 'solid',
        '&:hover': {
          backgroundColor: 'rgba(104, 58, 183, 0.16)',
        },
        ...sx,
      }}
      {...other}
    />
  );
} 